/**
 * Shared layout primitives for the preview hover card.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export const HoverSection: FC<{ label: string; children: ReactNode }> = ({
  label,
  children,
}) => (
  <section className="space-y-1.5">
    <h4 className="text-[9px] font-semibold uppercase tracking-[0.06em] text-muted-foreground">
      {label}
    </h4>
    <div className="space-y-1">{children}</div>
  </section>
);

export interface HoverMetricRowProps {
  label: string;
  primary: string;
  secondary: string | null;
  emphasis?: boolean;
  tone?: 'up' | 'down' | 'flat';
}

const TONE_TEXT: Record<NonNullable<HoverMetricRowProps['tone']>, string> = {
  up: 'text-emerald-600',
  down: 'text-destructive',
  flat: 'text-muted-foreground',
};

export const HoverMetricRow: FC<HoverMetricRowProps> = ({
  label,
  primary,
  secondary,
  emphasis,
  tone,
}) => (
  <div className="flex items-baseline justify-between gap-3">
    <span className="text-muted-foreground">{label}</span>
    <span className="flex items-baseline gap-2 tabular-nums">
      {secondary ? (
        <span className="text-[10px] text-muted-foreground">{secondary}</span>
      ) : null}
      <span
        className={cn(
          'font-semibold text-foreground',
          emphasis && 'text-primary',
          tone && TONE_TEXT[tone],
        )}
      >
        {primary}
      </span>
    </span>
  </div>
);
